import {
  isDniFeatureEnabled,
  isDniRegisteredFeatureEnabled
} from '@/config/featureFlags';
import { IdentificationDocumentTypes } from '@/modules/shared/types/IdentificationDocumentType';

import type { ICustomer } from '../../interfaces/src/bff-web/billing';
import type { IOrder } from '../../interfaces/src/bff-web/billing/interfaces/orderV2';

import type { IUserCustomerData } from './use-map-order-confirmation';

const getCustomerAddress = (order: IOrder, customer: IUserCustomerData) => {
  const { rut: customerRut, email: customerEmail } = customer;
  const { shippingAddress, billingAddress } = order ?? {};

  const shippingCustomerRut = shippingAddress?.custom?.fields?.customerRut;
  const billingCustomerRut = billingAddress?.custom?.fields?.customerRut;

  const rut = shippingCustomerRut ?? billingCustomerRut ?? customerRut;
  const firstName =
    shippingAddress?.firstName ??
    billingAddress?.firstName ??
    customer?.firstName ??
    '';
  const lastName =
    shippingAddress?.lastName ??
    billingAddress?.lastName ??
    customer?.lastName ??
    '';
  const fullName = `${firstName} ${lastName}`;
  const phone =
    shippingAddress?.phone ?? billingAddress?.phone ?? customer?.phone ?? '';
  const email =
    shippingAddress?.email ?? billingAddress?.email ?? customerEmail ?? '';
  const street = shippingAddress?.streetName ?? billingAddress?.streetName;
  const country = shippingAddress?.country ?? billingAddress?.country;
  const postalCode = shippingAddress?.postalCode ?? billingAddress?.postalCode;
  const isBill = !billingAddress?.custom?.fields?.isInvoice;

  const customerAddress: ICustomer = {
    isBill,
    rut,
    email: email,
    customerName: fullName,
    phone: phone,
    firstName: firstName,
    lastName: lastName,
    street: street,
    city: '',
    region: '',
    country: country,
    postCode: postalCode,
    documentID: '',
    documentType: IdentificationDocumentTypes.RUT
  };

  const isRegistered = !!order.customerId;
  const isDniEnabled = isRegistered
    ? isDniRegisteredFeatureEnabled()
    : isDniFeatureEnabled();

  if (isDniEnabled) {
    customerAddress.documentID = isRegistered
      ? customer.documentID
      : shippingAddress.custom.fields.documentID;
    customerAddress.documentType = isRegistered
      ? customer.documentType
      : shippingAddress.custom.fields.documentType;
  }

  return customerAddress;
};

export default getCustomerAddress;
